import ReactGA from "react-ga4";

const TRACKING_ID = "G-SM1Q2TFZR9"; 

export const initGA = () => {
    ReactGA.initialize(TRACKING_ID);
};
export const logPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
export const logEvent = (category, action, label, value) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
        value: value,
    });
};